import { render, staticRenderFns } from "./EditTestmonialComponent.vue?vue&type=template&id=c1417e0e"
import script from "./EditTestmonialComponent.vue?vue&type=script&lang=js"
export * from "./EditTestmonialComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports